import React from "react";

import { inputTypes, addInputType } from "./inputTypes";
import QuestionPanel from "./questionPanel";

import Log from "../../Log";
import { environment } from "../../constants";

class Forms extends React.Component {
  constructor(props) {
    super(props);
    this.formComponent = null;
    this.panelHistory = [];
    const schema = Object.assign(
      {},
      {
        classes: {},
        formPanels: [],
        questionPanels: [],
        questionSets: [],
      },
      props.schema
    );
    schema.formPanels = schema.formPanels.sort((a, b) => a.index > b.index);
    const panelId =
      typeof props.panelId !== "undefined"
        ? props.panelId
        : schema.formPanels.length > 0
        ? schema.formPanels[0].panelId
        : undefined;
    const currentPanel =
      typeof schema !== "undefined" &&
      typeof schema.formPanels !== "undefined" &&
      typeof panelId !== "undefined"
        ? schema.formPanels.find(function (o) {
            return o.panelId === panelId;
          })
        : undefined;

    if (!currentPanel) {
      throw new Error(
        "Forms: Could not find initial panel and failed to render."
      );
    }

    const totalQuestions = this.getQuestionTotal(schema);

    this.state = {
      schema: schema,
      currentPanel: currentPanel,
      action: props.action,
      questionAnswers: props.questionAnswers,
      currentQuestion: 0,
      totalQuestions: totalQuestions,
      form: [],
      error: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      action: nextProps.action,
      schema: nextProps.schema,
      questionAnswers: nextProps.questionAnswers,
    });
  }

  getQuestionTotal = (schema) => {
    const add = (a, b) => a + b;
    return Object.keys(schema.questionSets)
      .map((qs) => {
        return schema.questionSets[qs].questions.length;
      })
      .reduce(add);
  };

  handleAnswerChange(questionId, questionAnswer) {
    Log.trace("questionAnswers", this.state.questionAnswers);
    const questionAnswers = Object.assign(this.state.questionAnswers, {
      [questionId]: questionAnswer,
    });

    const currentQuestions = Object.keys(this.state.questionAnswers).length;

    this.setState(
      (state) => {
        return {
          questionAnswers: questionAnswers,
          currentQuestion: currentQuestions,
        };
      },
      this.props.onUpdate.bind(null, {
        questionAnswers,
        currentCount: this.state.currentQuestion,
        totalCount: this.state.totalQuestions,
      })
    );
  }

  handleSwitchPanel(panelId, preventHistory) {
    const panel = this.props.schema.formPanels.find((item) => {
      return item.panelId === panelId;
    });

    if (!panel) {
      throw new Error(
        'Forms: Tried to switch to panel "' +
          panelId +
          '", which does not exist.'
      );
    }

    if (!preventHistory) {
      this.panelHistory.push(panel.panelId);
    }

    this.setState(
      {
        currentPanel: panel,
      },
      this.props.onSwitchPanel.bind(null, panel)
    );
  }

  handleBackButtonClick() {
    this.panelHistory.pop();

    this.handleSwitchPanel.call(
      this,
      this.panelHistory[this.panelHistory.length - 1],
      true
    );
  }

  async handleSubmit(action) {
    if (this.props.disableSubmit) {
      await this.postSubmission(this.state.questionAnswers);

      this.props.onSubmit(
        this.state.questionAnswers,
        action,
        this.handleSwitchPanel.bind(this)
      );

      return;
    }

    /*
     * If we are not disabling the functionality of the form,
     * we need to set the action provided in the form, then submit.
     */
    this.setState(
      {
        action: action,
      },
      () => {
        if (!this.formComponent) {
          return;
        }

        this.formComponent.submit();
      }
    );
  }

  async postSubmission(dataRightsRequest) {
    const submitUrl =
      environment === "PRODUCTION"
        ? "/api/formsave"
        : "http://localhost:4505/formsave";

    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    try {
      const response = await fetch(submitUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(dataRightsRequest),
        redirect: "follow",
      });

      const body = await response.json();

      if (response.status !== 200) {
        throw new Error(
          body?.error || `${response.status} ${response.statusText}`
        );
      }

      console.log(body);
    } catch (error) {
      console.error(error);
      this.setState({ error: String(error) });
      throw new Error(String(error));
    }
  }

  render() {
    const currentPanel = this.state.schema.questionPanels.find((o) => {
      return o.panelId === this.state.currentPanel.panelId;
    });

    return (
      <>
        <form
          method={this.props.method}
          encType={this.props.encType}
          action={this.state.action}
          ref={(ref) => (this.formComponent = ref)}
          className={this.state.schema.classes.form}
        >
          <div className={this.state.schema.classes.questionPanels}>
            <QuestionPanel
              schema={this.state.schema}
              classes={this.state.schema.classes}
              panelId={currentPanel.panelId}
              panelIndex={currentPanel.panelIndex}
              panelHeader={currentPanel.panelHeader}
              panelText={currentPanel.panelText}
              panelFootnote={currentPanel.panelFootnote}
              action={currentPanel.action}
              button={currentPanel.button}
              backButton={currentPanel.backButton}
              questionSets={currentPanel.questionSets}
              questionAnswers={this.state.questionAnswers}
              panelHistory={this.panelHistory}
              renderError={this.props.renderError}
              renderRequiredAsterisk={this.props.renderRequiredAsterisk}
              onAnswerChange={this.handleAnswerChange.bind(this)}
              onPanelBack={this.handleBackButtonClick.bind(this)}
              onSwitchPanel={this.handleSwitchPanel.bind(this)}
              onSubmit={this.handleSubmit.bind(this)}
              onValidationErrors={this.props.onValidationErrors}
            />
            {this.state.error && (
              <div className="alert alert-warning my-3 p-3">
                {this.state.error}
              </div>
            )}
          </div>
        </form>
      </>
    );
  }

  componentDidMount() {
    this.panelHistory.push(this.state.currentPanel.panelId);
    this.props.onRender();
  }
}

Forms.inputTypes = inputTypes;
Forms.errorMessages = require("./lib/errors");
Forms.validation = require("./lib/validation");

Forms.addInputType = addInputType;
Forms.addInputTypes = Forms.inputTypes.addInputTypes;

Forms.addErrorMessage = Forms.errorMessages.addErrorMessage;
Forms.addErrorMessages = Forms.errorMessages.addErrorMessages;

Forms.addValidationMethod = Forms.validation.addValidationMethod;
Forms.addValidationMethods = Forms.validation.addValidationMethods;

Forms.defaultProps = {
  questionAnswers: {},
  encType: "application/x-www-form-urlencoded",
  method: "POST",
  action: "/api/formsave",
  panelId: undefined,
  disableSubmit: false,
  renderError: undefined,
  renderRequiredAsterisk: undefined,
  onSubmit: () => {},
  onUpdate: () => {},
  onSwitchPanel: () => {},
  onRender: () => {},
};

export default Forms;
